import { createContext, Dispatch, SetStateAction, useContext } from 'react';
import { RequestType } from 'models/item-request.model';
import { ActiveType } from 'models/vendors.model';
import { CreateUserType } from './provider';
import { RoleType } from 'models/role.model';

export type SettingsContextType = {
  setUsersToEdit: Dispatch<SetStateAction<RequestType>>;
  usersToEdit: RequestType;
  active: ActiveType | null;
  setActive: (item: ActiveType | null) => void;
  step: number;
  setStep: (value: number) => void;
  userFormData: CreateUserType[];
  setUserFormData: Dispatch<SetStateAction<CreateUserType[]>>;
  roles: RoleType[];
  setRoles: Dispatch<SetStateAction<RoleType[]>>;
};

export const SettingsContext = createContext({} as SettingsContextType);
const useSettingsContext = () => {
  const context = useContext(SettingsContext);
  return context;
};

export default useSettingsContext;
